import type {RouteParams} from 'types/routes'
import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {Index} from 'pages/withAuth/adminPage/settings/customMails/index'
import {Edit} from 'pages/withAuth/adminPage/settings/customMails/[emailType]'

export const customMailsRoutes: RouteParams[] = [
  {
    key: 'settings/custom_mails',
    path: WITH_AUTH_ADMIN_PATHS.SETTINGS.CUSTOM_MAILS.INDEX,
    component: Index,
    exact: true,
    whiteList: ['full_admin', 'office_admin'],
  },
  {
    key: '/settings/custom_mails/:emailType',
    path: WITH_AUTH_ADMIN_PATHS.SETTINGS.CUSTOM_MAILS.EDIT,
    component: Edit,
    exact: true,
    whiteList: ['full_admin', 'office_admin'],
  },
]
